import { useSalesTermWithTime } from "@/components/features/items/edit/_shared/ui/components/main/questions/sales-term-with-time/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanSaleTerm = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { saleTypeForTerm, saleStart, saleEnd, saleStartTime, saleEndTime, stayableStart, stayableEnd } = viewModel;

	return useSalesTermWithTime({
		saleTypeForTerm,
		saleStart,
		saleEnd,
		saleStartTime,
		saleEndTime,
		stayableStart,
		stayableEnd,
		onSetViewModel,
	});
};
